import type { DecisionState, OrderScenario } from '@/types/commerce'

export const DECISION_LABELS: Record<DecisionState, string> = {
  normal_feasible: 'Feasible as requested',
  conditionally_feasible: 'Conditionally feasible',
  alternative_required: 'Alternative required',
  not_feasible: 'Not feasible',
  unverified: 'Unverified',
}

export const DECISION_COLORS: Record<DecisionState, string> = {
  normal_feasible: 'bg-success/10 text-success',
  conditionally_feasible: 'bg-warning/10 text-warning-strong',
  alternative_required: 'bg-info/10 text-info',
  not_feasible: 'bg-destructive/10 text-destructive',
  unverified: 'bg-muted text-muted-foreground',
}

export const SCENARIO_STATUS_LABELS: Record<OrderScenario['status'], string> = {
  candidate: 'Candidate',
  selected: 'Selected',
  rejected: 'Rejected',
}

export const SCENARIO_STATUS_COLORS: Record<OrderScenario['status'], string> = {
  candidate: 'bg-muted text-muted-foreground',
  selected: 'bg-success/10 text-success',
  rejected: 'bg-muted text-muted-foreground/70',
}

// SA-1076 / SA-1041: one verb, "Record", for the action that ends the
// feasibility wait — the section, the band and the task page say the same.
export const RECORD_RESULT = 'Record feasibility result'
export const RECORD_ANOTHER_RESULT = 'Record another result'
export const SAVE_RESULT = 'Save result'
export const ADDS_A_RESULT = 'This adds a new result. The newest is shown here; earlier ones stay in the record’s activity.'
export const awaitedChip = (stepNumber: number) => `Step ${stepNumber} waits for this`
export const awaitedLine = (stepNumber: number, stepTitle: string) => `Recording a result here ends step ${stepNumber} ${stepTitle}.`
export const recordedBeforeLine = (stepNumber: number) => `Recorded before step ${stepNumber} opened. Record it again to continue.`
export const waitTaskLine = (stepNumber: number, stepTitle: string) =>
  `Step ${stepNumber} ${stepTitle} ends when a result is recorded in the record’s Feasibility section.`
